import { Grid } from "@mui/material";
import { AppLabel, AppValue } from ".";
import { ENUM_LABEL_VALUE_TYPES } from "../../../enums";
import { ChipList } from "../chip";

function LabelAndValue({
  label,
  value,
  renderValue,
  valueComponent,
  componentProps,
  rootProps,
  labelProps,
  valueProps,
  labelWrapperProps,
  valueWrapperProps,
}: any) {
  const valueRenderer = () => {
    if (renderValue) return renderValue();

    switch (valueComponent) {
      case ENUM_LABEL_VALUE_TYPES.CHIP_LIST:
        return <ChipList flatList list={value} chipProps={componentProps} />;

      default:
        return <AppValue value={value} {...valueProps} />;
    }
  };

  return (
    <Grid container {...rootProps}>
      <Grid item xs={12} {...labelWrapperProps}>
        <AppLabel label={label} {...labelProps} />
      </Grid>
      <Grid item xs={12} {...valueWrapperProps}>
        {valueRenderer()}
      </Grid>
    </Grid>
  );
}

export { LabelAndValue };
